
const BASE_PATH = '';

const baseRequestUrl = 'https://pms.suanju.net/api';

module.exports = {
    BASE_PATH,
    baseRequestUrl
};
